var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "language-list" }, _vm._l(_vm.languages, function (language) {
    return _c('div', { key: language.zip_sign, staticClass: "language" }, [_c('div', [_c('h6', [_c('span', [_vm._v(_vm._s(language.zip_sign.toUpperCase()))]), _vm._v(" "), _vm._t("header-tail", null, { "language": language })], 2), _vm._v(" "), _c('resource-list', _vm._g({ attrs: { "resource-list": _vm.getResourceList(language), "language": language, "selectable": false }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
          var resource = _ref.resource;
          return [_c('div', { staticClass: "resource-item-inner" }, [_c('span', [_c('img', { attrs: { "src": resource.file_url } })])])];
        } }, { key: "resource-handler", fn: function fn(_ref2) {
          var resource = _ref2.resource,
              index = _ref2.index;
          return [_c('res-list-handler', { attrs: { "resource": resource, "index": index, "changeable": _vm.isUpdatable(language), "editable": _vm.isUpdatable(language) }, scopedSlots: _vm._u([{ key: "update-btn", fn: function fn(_ref3) {
                var resource = _ref3.resource,
                    index = _ref3.index;
                return [_c('div', { staticClass: "action-more-item", on: { "click": function click($event) {
                      $event.stopPropagation();$event.preventDefault();return _vm.handleChange({ resource: resource, index: index, language: language });
                    } } }, [_vm._v(_vm._s(_vm.$t('playTurbo.custom.resourceDialog.handlerRelated.update')))])];
              } }, { key: "edit-btn", fn: function fn(_ref4) {
                var resource = _ref4.resource,
                    index = _ref4.index;
                return [_vm._t("edit-btn", null, { "resource": resource, "index": index })];
              } }], null, true) })];
        } }], null, true) }, _vm.$listeners))], 1)]);
  }), 0);
};
var staticRenderFns = [];

export { render, staticRenderFns };